var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { ORG_CONTEXT_CHANGE } from '../actions/index';
import { INITIAL_DATA_LIST_STATE } from './data-list.state';
var ReducerStateFactory = /** @class */ (function () {
    function ReducerStateFactory(actionClass, _initialState) {
        if (_initialState === void 0) { _initialState = {}; }
        this.actionClass = actionClass;
        this._initialState = _initialState;
    }
    Object.defineProperty(ReducerStateFactory.prototype, "initialState", {
        get: function () {
            return __assign({}, INITIAL_DATA_LIST_STATE, this._initialState);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * The reducer function
     */
    ReducerStateFactory.prototype.reducer = function (state, action) {
        if (state === void 0) { state = this.initialState; }
        var allResult = this.allReducer(state, action);
        if (allResult) {
            return allResult;
        }
        var entityResult = this.entityReducer(state, action);
        if (entityResult) {
            return entityResult;
        }
        switch (action.type) {
            case this.actionClass.RESPONSE_FAIL:
                var error = action.payload.code || action.payload;
                return __assign({}, state, { error: error });
            case this.actionClass.SELECT_BY_ID:
                return __assign({}, state, { selectedId: action.payload.id });
            default:
                return state;
        }
    };
    ReducerStateFactory.prototype.allReducer = function (state, action) {
        switch (action.type) {
            case this.actionClass.PAGE_CHANGE:
                return __assign({}, state, { page: action.payload });
            case this.actionClass.UPDATE_FILTER:
                return __assign({}, state, { filter: action.payload, page: __assign({}, state.page) });
            case this.actionClass.RESET_PAGE:
                return __assign({}, state, { page: __assign({}, INITIAL_DATA_LIST_STATE.page) });
            case this.actionClass.REQUEST_ALL:
                return __assign({}, state, { loadingAll: true });
            case this.actionClass.RESPONSE_SUCCESS_COUNT:
                return __assign({}, state, { page: __assign({}, state.page, { length: action.payload }) });
            case this.actionClass.REQUEST_SEARCH:
                return __assign({}, state, { searching: true, searchResults: [] });
            case this.actionClass.RESPONSE_SUCCESS_SEARCH: {
                var searchResults = action.payload.map(function (org) { return org.id; });
                var ids = Array.from(new Set(state.ids.concat(searchResults)));
                var entities = __assign({}, state.entities, action.payload.reduce(function (acc, entity) {
                    var _a;
                    return (__assign({}, acc, (_a = {}, _a[entity.id] = entity, _a)));
                }, {}));
                return __assign({}, state, { searching: false, ids: ids, entities: entities, searchResults: searchResults });
            }
            case this.actionClass.RESPONSE_FAIL_SEARCH:
                return __assign({}, state, { searching: false });
            case this.actionClass.RESPONSE_SUCCESS_ALL: {
                var ids = action.payload.map(function (org) { return org.id; });
                var entities = action.payload.reduce(function (acc, entity) {
                    var _a;
                    return (__assign({}, acc, (_a = {}, _a[entity.id] = entity, _a)));
                }, {});
                return __assign({}, state, { loadingAll: false, ids: ids, entities: entities });
            }
            case this.actionClass.RESPONSE_FAIL_ALL: {
                return __assign({}, state, { loadingAll: false, error: action.payload });
            }
            case ORG_CONTEXT_CHANGE: {
                return __assign({}, state, { page: INITIAL_DATA_LIST_STATE.page, filter: INITIAL_DATA_LIST_STATE.filter });
            }
        }
    };
    ReducerStateFactory.prototype.entityReducer = function (state, action) {
        var _a, _b, _c, _d;
        switch (action.type) {
            // Request
            case this.actionClass.REQUEST_CREATE: {
                return __assign({}, state, { creating: true });
            }
            case this.actionClass.REQUEST_SAVE:
            case this.actionClass.REQUEST_BY_ID:
                return __assign({}, state, { loadingEntities: __assign({}, state.loadingEntities, (_a = {}, _a[action.payload.id] = true, _a)) });
            // Response Success
            case this.actionClass.RESPONSE_SUCCESS_SAVE:
            case this.actionClass.RESPONSE_SUCCESS_CREATE:
            case this.actionClass.RESPONSE_SUCCESS_BY_ID: {
                var ids = Array.from(new Set(state.ids.concat([action.payload.id])));
                var entities = __assign({}, state.entities, (_b = {}, _b[action.payload.id] = action.payload, _b));
                return __assign({}, state, { loadingEntities: __assign({}, state.loadingEntities, (_c = {}, _c[action.payload.id] = false, _c)), creating: false, ids: ids, entities: entities });
            }
            case this.actionClass.RESPONSE_FAIL_CREATE:
                return __assign({}, state, { creating: false });
            // Response Fail
            case this.actionClass.RESPONSE_FAIL_BY_ID:
            case this.actionClass.RESPONSE_FAIL_SAVE:
                return __assign({}, state, { loadingEntities: __assign({}, state.loadingEntities, (_d = {}, _d[action.payload.id] = false, _d)) });
        }
    };
    return ReducerStateFactory;
}());
export { ReducerStateFactory };
